import { SearchPatientResponse, PatientLightResponse, PatientSearchApi, SearchPatientRequest } from "@/apiGenerate/medserver";
import { medServerApiConfig } from "@/config/medserver-api.config";
import { formatMatricule } from "@/functions/lu";
import { Regex } from "@/models/share.model";
import { getFormattedCnsPrexisFromBirthdate } from "@/utils/date-utils";


class SearchPatientService {
    
    private patientSearchApi: PatientSearchApi;

    constructor() {
        this.patientSearchApi = new PatientSearchApi(medServerApiConfig);
    }
        
    async searchPatient(event: string, healthGroupMembershipsUuid: string[]): Promise<any[]> {    
        if (Regex.wildcardPostgre.test(event)) {
        return [];
        }
        if (event.length > 2) {
            const searchPatientRequest: SearchPatientRequest = {
                institutes: healthGroupMembershipsUuid
            }
            return this.patientSearchApi.searchPatient({ search: event.toLowerCase(), searchPatientRequest: searchPatientRequest }).then((response: SearchPatientResponse[]) => {
                return response.map((patient: SearchPatientResponse) => this.searchPatientResponsetoPatientLightResponse(patient))
                        .map((patientLightResponse: PatientLightResponse) => this.patientLightResponseToItemSelect(patientLightResponse));
        });
        } else {
            return [];
        }
    }

    private getSerialNumberOrBirthdate = (patientLightResponse: PatientLightResponse): string => {
        return patientLightResponse.serialNumber ? formatMatricule(patientLightResponse.serialNumber) : getFormattedCnsPrexisFromBirthdate(patientLightResponse.birthdate);
    }

    private getFisrtname = (patientLightReponse: any): string => {
        return patientLightReponse.firstName ? patientLightReponse.firstName : patientLightReponse.firstname;
    };

    private getLastname = (patientLightReponse: any): string => {
        return patientLightReponse.lastName ? patientLightReponse.lastName : patientLightReponse.lastname;
    };

    public patientLightResponseToItemSelect = (patientLightResponse: any) => ({
        id: patientLightResponse.patientId,
        label: this.getLastname(patientLightResponse).toUpperCase() + ' ' + this.getFisrtname(patientLightResponse) + ' ' + this.getSerialNumberOrBirthdate(patientLightResponse),
        pwrPatient : patientLightResponse
    });

    private searchPatientResponsetoPatientLightResponse = (searchPatientResponse: SearchPatientResponse) =>({
    patientId: searchPatientResponse.personWithRoleId,
    birthdate: searchPatientResponse.birthDate,
    serialNumber: searchPatientResponse.cnsAffiliationNumber,
    lastName: searchPatientResponse.lastName,
    firstName: searchPatientResponse.firstName
    })

}


export default new SearchPatientService();